<template>
  <!-- Innovadis custom showCurrencyLocal -->
  <span v-if="showCurrencyLocal">{{ value?.formattedAmount ?? "N/A" }}</span>
  <span v-else>{{ value?.formattedAmountWithoutCurrency ?? "N/A" }}</span>
</template>

<script setup lang="ts">
import type { MoneyType } from "@/core/api/graphql/types";

interface IProps {
  value?: Pick<MoneyType, "formattedAmount" | "formattedAmountWithoutCurrency">;
  showCurrencyLocal?: boolean;
}

defineProps<IProps>();
</script>
